<div class="media-asset">
  <div class="media-asset-visualizer">
    <video
      #video
      class="object-contain w-full m-auto"
      [src]="videoURL$ | async"
      [poster]="(asset.imageUrl || asset.previewUrl)! | imageLoading | async"
      preload="none"
      [controlsList]="!(asset.expiryDate | dateNotExpired) ? 'nodownload' : ''"
      (error)="onError()"
      controls
    >
      Your browser does not support HTML video.
    </video>
  </div>
</div>
